import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import HexButtonBackground from './HexButtonBackground';


interface HexButtonProps {
  children: object | string,
  type?: 'submit' | 'reset' | 'button' | undefined,
  isGrid?: boolean,
}

const RedHexButton = ({
  type = 'button',
  isGrid = false,
  children,
  ...otherProps
}: HexButtonProps) => {
  const data = useStaticQuery(graphql`
    query {
      redButtonSvg: file(name: { eq: "redHex" }) {
        publicURL
      }
    }
  `);

  return (
    <HexButtonBackground
      backgroundimage={data.redButtonSvg.publicURL}
      type={type}
      isGrid={isGrid}
      {...otherProps}
    >
      <span className="redButtonTitle">
        {children}
      </span>
    </HexButtonBackground>
  );
};

export default RedHexButton;
